import React from 'react';
import { CircularGraph } from '../circular-graph';
import { Link } from '@reach/router';
import styles from './button-graph.module.scss';
import { Icon } from '../icon';

interface Props {
  href: string;
  title: string;
  percentage?: number;
  color?: string;
  icon?: string;
}

export const ButtonGraph: React.FC<Props> = ({ href, percentage, title, color, icon }) => (
  <Link to={href} className={styles.button}>
    {percentage ? (
      <CircularGraph percentage={percentage} title={title} color={color} icon={icon} />
    ) : (
      <>
        {icon && <Icon type={icon} label={title} className={styles.icon} />}
        <h2>{title}</h2>
      </>
    )}
  </Link>
);
